import React from 'react'

const IconSVG = ({ style = {}, ...props }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}>
      <path
        d="M21.704 8a10.016 10.016 0 0 0-7.384-1.6l1.896-1.896a2.2 2.2 0 1 0-1.128-1.128L11.2 7.2h-4v4l-3.736 3.744a2.2 2.2 0 1 0 1.128 1.136l1.76-1.76a10.032 10.032 0 0 0 1.6 7.28V24h4.8v-4.8H8.44A8.68 8.68 0 0 1 8.8 12H12V8.8a8.68 8.68 0 0 1 7.112-.408V12.8h4.8V8h-2.208z"
        fill="#77ca34"
      />
    </svg>
  )
}

export default IconSVG
